import type { ListItemBlock } from "./schema/blocks/list-item.js";
import type { BriefBlock } from "./schema/index.js";

export function createListItem(
    props?: Partial<Pick<ListItemBlock, "ordered" | "depth" | "html">>,
): ListItemBlock {
    return {
        id: crypto.randomUUID(),
        type: "listItem",
        html: props?.html ?? "",
        ordered: props?.ordered ?? false,
        depth: props?.depth ?? 0,
    };
}

export function getListItemMarker(blocks: BriefBlock[], index: number): string {
    const block = blocks[index];
    if (!block || block.type !== "listItem") return "";
    if (!block.ordered) return "•";
    let number = 1;
    for (let current = index - 1; current >= 0; current--) {
        const previous = blocks[current];
        if (!previous || previous.type !== "listItem") break;
        if (previous.depth < block.depth) break;
        if (previous.depth === block.depth) {
            if (!previous.ordered) break;
            number += 1;
        }
    }
    return `${number}.`;
}

export function nextListItemDepth(
    block: ListItemBlock,
    previous: BriefBlock | undefined,
    delta: number,
): number {
    if (delta < 0) return Math.max(0, block.depth + delta);
    const maxDepth = previous?.type === "listItem" ? previous.depth + 1 : 0;
    return Math.min(block.depth + delta, maxDepth);
}
